import { render, staticRenderFns } from "./NotApprovedCosts.vue?vue&type=template&id=7c622718&"
import script from "./NotApprovedCosts.vue?vue&type=script&lang=js&"
export * from "./NotApprovedCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports